import { useDispatch } from 'react-redux';
import { setActivePage } from '../../store/slices/appSlice';
import './Header.css'
import UserAvatar from './UserAvatar'
import LanguageSwitcher from './LanguageSwitcher'
import Logo from './Logo';
import { CategoryTabs } from '../ToolsPanel/CategoryTabs';


const Header = () => {
	const dispatch = useDispatch();
	const onLogoClick = () => {
		dispatch(setActivePage('calculator'));
	}

	return (
		<header className="header">
			<Logo onClick={onLogoClick} />
			<CategoryTabs />
			<div className="header__actions">
				<LanguageSwitcher />
				<UserAvatar />
			</div>
		</header>
	)
}

export default Header
